import { fetchWrapper } from './fetchWrapper'

export function getConfig() {
  return fetchWrapper('/wp-json/pokercoaching/v1/get_react_config')
    .then((res) => res.json())
    .then((res) => {
      if (!res.success) {
        throw Error(res.data.message)
      }

      return res.config
    })
}
